import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

import { DataTrendIcon } from './DataTrendIcon';
import { dataCardStyles } from './data-card-helper';
import { CardLoader } from 'components';

export interface DataCardProps {
    label?: string;
    value?: string;
    trend?: string;
    children?: React.ReactNode;
    isLoading?: boolean;
}

export const DataCard = (props: DataCardProps): React.JSX.Element => {
    const { value, label, trend, isLoading } = props;
    return (
        <Paper elevation={0} sx={dataCardStyles.root}>
            <Box>
                <Typography variant='overline' sx={dataCardStyles.insightLabel}>
                    {label}
                </Typography>

                <DataTrendIcon trendDirection={trend} />

                {isLoading ? (
                    <Typography
                        component={'span'}
                        variant='h4'
                        sx={dataCardStyles.insightValue}
                    >
                        <CardLoader />
                    </Typography>
                ) : (
                    <Typography
                        component={'span'}
                        variant='h4'
                        sx={{
                            ...dataCardStyles.insightValue,
                            ...(value === 'n/a' && dataCardStyles.noData),
                        }}
                    >
                        {value}
                    </Typography>
                )}
            </Box>
            {props.children}
        </Paper>
    );
};
